import { ordenTypeActions } from "../../store/ordentype-store/ordentype-slice";
import { uiActions } from "../../store/ui-slice";
import { useDispatch, useSelector } from "react-redux";
import { InputText } from "primereact/inputtext";
import { Message } from "primereact/message";
import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";
import { Card } from "primereact/card";
import { useEffect } from "react";
import { InputTextarea } from "primereact/inputtextarea";

let restartPage = false;
const OrdenTypeForms = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isValid = useSelector((state) => state.ordenType.ordenTypeValidation);
  const auth = useSelector((state) => state.auth);
  const ordentype = props.ordenType;
  const notification = useSelector((state) => state.ui.notification);

  useEffect(() => {
    if (
      notification &&
      notification.status === "success" &&
      ordentype.id > 0 &&
      restartPage
    ) {
      dispatch(ordenTypeActions.restartState());
      window.location.href = "/orden/types";
    }
  }, [dispatch, navigate, notification, ordentype.id]);

  const onChangeHandler = (id, value) => {
    dispatch(ordenTypeActions.modifyPropertyValue({ id, value }));
    if (id === "name") {
      if (value !== "") {
        dispatch(ordenTypeActions.setFieldValid({ id, value: true }));
      } else {
        dispatch(ordenTypeActions.setFieldValid({ id, value: false }));
      }
    }
  };

  const onSubmitHandler = (event) => {
    event.preventDefault();

    if (ordentype.name === "") {
      dispatch(ordenTypeActions.setFieldValid({ id: "name", value: false }));
      dispatch(
        uiActions.showNotification({
          status: "warning",
          title: "Advertencia",
          message: "Existen valores invalidos, favor de revisar.",
        })
      );
    } else {
      dispatch(props.actionOrdenType(ordentype, auth.UserInfo.email));
      restartPage = true;
    }
  };
  const getFormErrorMessage = (id) => {
    return !isValid[id].isValid ? (
      <Message severity="warn" text={isValid[id].errorMessage} />
    ) : (
      <small className="p-warn">&nbsp;</small>
    );
  };
  return (
    <>
      <Card
        style={{
          backgroundColor: "#142f47",
          marginLeft: "0%",
          marginTop: "-16px",
          boxShadow: "none",
          height: "100%",
          width: "98%",
        }}
      >
        <form onSubmit={onSubmitHandler}>
          <div className="formgrid grid">
            <div className="field col-12 md:col-12">
              <label
                htmlFor="description"
                style={{ fontSize: "large", color: "#35c4dc" }}
              >
                Tipo de Orden:
              </label>
              <InputText
                id="description"
                value={ordentype.name}
                onChange={(e) => onChangeHandler("name", e.target.value)}
                placeholder=""
                style={{ width: "100%" }}
              />
              <div>{getFormErrorMessage("name")}</div>
            </div>
            <div className="field col-12 md:col-12">
              <label
                htmlFor="description"
                style={{ fontSize: "large", color: "#35c4dc" }}
              >
                Descripción:
              </label>
              <InputTextarea
                rows={5}
                cols={30}
                id="description"
                value={ordentype.description}
                onChange={(e) => onChangeHandler("description", e.target.value)}
                placeholder=""
                style={{ width: "100%" }}
              />
            </div>
          </div>
          <div className="formgrid grid">
            <Button
              rounded
              text
              raised
              style={{ backgroundColor: "#fff" }}
              label="Regresar"
              icon="pi pi-arrow-left"
              className="p-button-danger"
              onClick={() => {
                navigate("/orden/types");
              }}
            />
            <Button
              rounded
              text
              raised
              style={{ backgroundColor: "#fff", marginLeft: "1%" }}
              label="Guardar"
              className="p-button-success"
              icon={
                notification && notification.status === "pending"
                  ? "pi pi-spin pi-spinner"
                  : "pi pi-save"
              }
              disabled={notification && notification.status === "pending"}
            />
          </div>
        </form>
      </Card>
    </>
  );
};
export default OrdenTypeForms;
